'use strict';

var $orderError = $('#orderno-error');
var $emailError = $('#email-error');
var $email = $('#emailinput');
var $orderNo = $('#orderno');

$orderNo.on('input', function () {
    $(this).val($(this).val().replace(/[^\w]/g, ''));
    if ($orderNo.val()) {
        $orderError.empty().html('');
        $orderError.removeClass('d-block');
        $orderNo.removeClass('is-invalid');
    }
});

$email.on('input', function () {
    $(this).val($(this).val().replace(/[^\w@.\-+]/g, ''));
    if ($email.val()) {
        $emailError.empty().html('');
        $emailError.removeClass('d-block');
        $email.removeClass('is-invalid');
    }
});

$('.trackorder-btn').on('click', function (event) {
    event.preventDefault();

    const ORDER_REGEX = /^[A-Za-z0-9]*$/;
    const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    var orderMissMsg = $orderNo ? $orderNo.attr('data-missing-error') : '';
    var orderNoErrMsg = $orderNo ? $orderNo.attr('data-errmsg') : '';
    var emailMissMsg = $email ? $email.attr('data-missing-error') : '';
    var emailErrMsg = $email ? $email.attr('data-errmsg') : '';
    var validInput = true;

    if (!$orderNo.val()) {
        $orderError.empty().html(orderMissMsg);
        $orderError.addClass('d-block');
        $orderNo.addClass('is-invalid');
        validInput = false;
    } else if (!ORDER_REGEX.test($orderNo.val())) {
        $orderError.empty().html(orderNoErrMsg);
        $orderError.addClass('d-block');
        $orderNo.addClass('is-invalid');
        validInput = false;
    } else {
        $orderError.empty().html('');
        $orderNo.removeClass('is-invalid');
    }

    if (!$email.val()) {
        $emailError.empty().html(emailMissMsg);
        $emailError.addClass('d-block');
        $email.addClass('is-invalid');
        validInput = false;
    } else if (!EMAIL_REGEX.test($email.val())) {
        $emailError.empty().html(emailErrMsg);
        $emailError.addClass('d-block');
        $email.addClass('is-invalid');
        validInput = false;
    } else {
        $emailError.empty().html('');
        $email.removeClass('is-invalid');
    }

    var dataForm = $('.form-section');

    if (validInput) {
        $orderError.removeClass('d-block');
        $emailError.removeClass('d-block');
        var url = $('.tracking-form').attr('action');
        $.ajax({
            url: url,
            type: 'post',
            data: dataForm.serialize(),
            success: function (data) {
                if (data.success) {
                    window.location.href = data.redirectURL;
                } else {
                    $('body').trigger('failureToast', data.msg);
                }
            },
            error: function () {
                // error
            }
        });
    }
});
